<template>
    <div class="shop-rec">
        <div class="part-title fix">
            <i class="icon icon-shop l"></i>
            <slot name="titleText"></slot>
            <slot name="more"></slot>
        </div>
        <div class="shop-list">
            <ul class="fix">
                <router-link tag="li" v-for="item in shopRec.slice(0, 4)" :key="item.Id" :to="`/commodity/detail?Id=${item.Id}`">
                    <div class="pic-box">
                        <img :src="item.ImageUrl" :alt="item.Name">
                    </div>
                    <div class="text-box">
                        <p class="el">{{ item.Name }}</p>
                        <div class="price">
                            <span class="price-new">{{ item.Price }}积分</span>
                            <span class="price-old" v-if="item.OldPrice">{{ item.OldPrice }}积分</span>
                        </div>
                    </div>
                    <div class="pro-tip" v-if="tag = item.GiftTags[0]">
                        <span class="hvc" :style="`background-color: #${ tag.BackgroundColor }; color: #${ tag.FontColor }`">{{ tag.Name }}</span>
                    </div>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShopRec',
        props: ['rec'],
        watch: {
            'rec': function () {
                this.update()
            }
        },
        mounted () {
            this.update()
        },
        data () {
            return {
                shopRec: []
            }
        },
        methods: {
            update () {
                this.shopRec = this.rec
            }
        }
    }
</script>

<style lang="less" scoped>
    .shop-rec{
        .part-title{
            padding-top: 30px;
            padding-bottom: 14px;
            .icon-shop{
                width: 33px;
                height: 33px;
                background: url("../../assets/images/icon_shop_rec.png") no-repeat;
                background-size: 100% 100%;
            }
            h3{
                float: left;
                padding-left: 9px;
                font-size: 22px;
                line-height: 35px;
            }
            .shop-more{
                height: 35px;
                color: #4a90e2;
                line-height: 40px;
            }
        }
        .shop-list{
            background-color: #fff;
            border: #d4dbde solid 1px;
            ul{
                li{
                    float: left;
                    position: relative;
                    height: 226px;
                    padding: 14px 15px 14px 14px;
                    cursor: pointer;
                    &::after{
                        content: "";
                        display: block;
                        position: absolute;
                        right: 0;
                        top: 50%;
                        width: 1px;
                        height: 156px;
                        margin-top: -78px;
                        background: url("../../assets/images/right_line.jpg") no-repeat;
                    }
                    &:last-child{
                        &::after{
                            display: none;
                        }
                    }
                    .pic-box{
                        width: 207px;
                        height: 132px;
                        overflow: hidden;
                        img{
                            width: 100%;
                        }
                    }
                    .text-box{
                        padding-top: 10px;
                        p{
                            line-height: 23px;
                            font-size: 16px;
                        }
                        .price-new{
                            font-size: 20px;
                            color: #ffa70d;
                            line-height: 28px;
                        }
                        .price-old{
                            padding-left: 8px;
                            font-size: 14px;
                            color: #747d80;
                            line-height: 28px;
                            text-decoration: line-through;
                        }
                    }
                    .pro-tip{
                        position: absolute;
                        left: 14px;
                        top: 14px;
                        span{
                            width: 79px;
                            height: 24px;
                            border-bottom-right-radius: 8px;
                            color: #fff;
                            text-align: center;
                            line-height: 24px;
                        }
                    }
                }
            }
        }
    }
</style>
